import axios from "../utils/axios";

/**
 * List all pages with pagination and filtering
 * @param {Object} params - Query parameters (page, per_page, search, etc.)
 * @returns {Promise} Pages list
 */
export const getPages = async (params) => {
    try {
        const { data } = await axios.get('/admin/pages', { params });
        return data;
    } catch (error) {
        console.error("🚀 ~ getPages ~ error:", error);
        throw error;
    }
};

/**
 * Get a single page by ID
 * @param {number|string} id - Page ID
 * @returns {Promise} Page data
 */
export const getPageById = async (id) => {
    try {
        const { data } = await axios.get(`/admin/pages/${id}`);
        return data;
    } catch (error) {
        console.error("🚀 ~ getPageById ~ error:", error);
        throw error;
    }
};

/**
 * Create a new page
 * @param {Object} pageData - Page data
 * @returns {Promise} Created page
 */
export const createPage = async (pageData) => {
    try {
        const { data } = await axios.post('/admin/pages', pageData);
        return data;
    } catch (error) {
        console.error("🚀 ~ createPage ~ error:", error);
        throw error;
    }
};

/**
 * Update an existing page
 * @param {number|string} id - Page ID
 * @param {Object} pageData - Updated page data
 * @returns {Promise} Updated page
 */
export const updatePage = async (id, pageData) => {
    try {
        const { data } = await axios.put(`/admin/pages/${id}`, pageData);
        return data;
    } catch (error) {
        console.error("🚀 ~ updatePage ~ error:", error);
        throw error;
    }
};

/**
 * Delete a page
 * @param {number|string} id - Page ID
 * @returns {Promise} Result of deletion
 */
export const deletePage = async (id) => {
    try {
        const { data } = await axios.delete(`/admin/pages/${id}`);
        return data;
    } catch (error) {
        console.error("🚀 ~ deletePage ~ error:", error);
        throw error;
    }
};
